import { Request } from "./HttpService";

export const TagService = {
  getTags() {
    return Request("vitae/tag", "GET").then((data) => {
      return data;
    });
  },
  getTagsList() {
    return Request("vitae/tag/list", "GET").then((data) => {
      return data;
    });
  },
  getGroups() {
    return Request("vitae/tagGroup", "GET").then((data) => {
      return data;
    });
  },
  createTag(tag) {
    return Request("vitae/tag", "POST", tag).then((data) => {
      return data;
    });
  },
  update(tag) {
    return Request("vitae/tag", "PUT", tag).then((data) => {
      return data;
    });
  },
  deleteTag(id) {
    return Request(`vitae/tag/${id}`, "DELETE").then((data) => {
      return data;
    });
  }
};
